import template from './invalid-entry-messaging.component.html';

class InvalidEntryMessagingController {
	constructor() {}

	$onInit() {
		if (!this.min) {
			this.min = 0;
		}

		if (!this.max) {
			this.max = 0;
		}
	}

	$onDestroy() {}
}

export const invalidEntryMessagingComponent = {
	template,
	controller: InvalidEntryMessagingController,
	controllerAs: 'vm',
	bindings: {
		show: '<',
		errorType: '<',
		min: '<?',
		max: '<?'
	}
};
